module.exports = __webpack_public_path__ + "static/media/Ubuntu-Light.277289c5.ttf";